module.exports = __webpack_public_path__ + "static/media/Desafio6-c.45d6149b.mp4";